import { styled } from '@mui/material/styles';

export const MainContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  z-index: 1000;
`;
